import { MonitorWithMetadata } from "../contexts/FindingsContext";
import { MonitorModal } from "./Monitors";

export const EditMonitorModal: React.FC<{
  editModalOpen: boolean;
  closeEditModal: () => void;
  modalMonitor: MonitorWithMetadata | undefined;
  isCustom: boolean;
}> = ({ editModalOpen, closeEditModal, modalMonitor, isCustom }) => {
  return (
    <MonitorModal
      mode="edit-monitor"
      open={editModalOpen}
      onCancel={closeEditModal}
      monitor={modalMonitor}
      isCustom={isCustom}
    />
  );
};
